import Marquee from "react-fast-marquee";

// Publications / media outlets that have covered JP's work.
// Rendered as a marquee of typographic wordmarks — zero logo image dependencies.
const OUTLETS = [
  "High Times",
  "PR Newswire",
  "Chicago Tribune",
  "The Seattle Times",
  "The Tennessean",
  "KIRO7 News",
  "Sign Media",
  "Mural Routes",
  "8th Light",
  "Muros",
];

export default function PressRibbon() {
  return (
    <section
      data-testid="press-ribbon"
      aria-label="Featured press and publications"
      className="bg-[#F2EFE9] border-t border-b border-[#111111]"
    >
      <div className="flex flex-col md:flex-row md:items-stretch">
        <div className="md:w-64 shrink-0 border-b md:border-b-0 md:border-r border-[#111111] px-6 py-5 flex flex-col justify-center">
          <div className="font-mono-s text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A]">
            As seen in
          </div>
          <div className="font-anton uppercase text-2xl md:text-3xl leading-tight mt-1">
            Featured &amp; cited.
          </div>
        </div>
        <div className="flex-1 py-5 md:py-6 overflow-hidden">
          <Marquee gradient={false} speed={42} pauseOnHover>
            {OUTLETS.map((o, i) => (
              <span
                key={i}
                className="font-cormorant italic text-2xl md:text-3xl px-8 md:px-10 text-[#111111] whitespace-nowrap"
              >
                {o}
                <span className="ml-8 md:ml-10 font-mono-s text-sm text-[#D83127]">◆</span>
              </span>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
